import DemoForm from '../landing/components/DemoForm';

export default function DemoPage() {
  return <DemoForm />;
}
